import spriteSvg from '@/assets/images/sprite.svg';

type Props = {
  className?: string;
  name: string;
};

export const SpriteSvg = (props: Props) => {
  return (
    <svg className={props.className}>
      <use xlinkHref={`${spriteSvg}#${props.name}`} />
    </svg>
  );
};
